document.addEventListener('alpine:init', () => {
  Alpine.data('CartAttributes', () => {
    return {
      updating: false,
      note: '',
      attributes: {
        To: '',
        From: '',
        Message: '',
      },
      init() {
        /**
         * Can’t use .fill here because it conflicts
         * with .debounce for some reason
         */
        this.note = this.$root.getAttribute('data-note') || '';
        this.attributes.To = this.$root.getAttribute('data-to') || '';
        this.attributes.From = this.$root.getAttribute('data-from') || '';
        this.attributes.Message = this.$root.getAttribute('data-message') || '';

        // Watch for changes and update cart
        this.$watch('note', () => this.updateCartAttributes());
        this.$watch('attributes.To', () => this.updateCartAttributes());
        this.$watch('attributes.From', () => this.updateCartAttributes());
        this.$watch('attributes.Message', () => this.updateCartAttributes());
      },
       async updateCartAttributes() {
        this.updating = true;
        try {
          const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              note: this.note,
              attributes: this.attributes,
            }),
          });
          if (!response.ok) {
            console.error('Failed to update cart:', response.statusText);
          }
        } catch (error) {
          console.error('Error updating cart:', error);
        } finally {
          this.updating = false;
        }
      },
    };
  });
});
